export default "__VITE_ASSET__d1de45db__"